customElements.get("details-disclosure") || customElements.define("details-disclosure", class extends HTMLElement {
  constructor() {
    super(), this.initial = !0, this.details = this.querySelector("details"), this.summary = this.querySelector("summary"), 
    this.scrollLock = this.hasAttribute("data-scroll-lock"), this.isMenu = this.hasAttribute("data-menu"), 
    this.details?.addEventListener("toggle", this.onToggle.bind(this)), this.addEventListener("click", this.onClick.bind(this)), 
    this.details.hasAttribute("open") && this.onToggle();
  }
  onFocusOut() {
    setTimeout((() => {
      this.contains(document.activeElement) || this.close();
    }));
  }
  onClick(t) {
    t.target?.hasAttribute("data-close") ? (t.preventDefault(), this.close()) : t.target?.hasAttribute("data-close-parent") && this.closeParentDetails(t);
  }
  onToggle() {
    this.animations || (this.animations = this.summary.getAnimations()), this.details.hasAttribute("open") ? this.animations.forEach((t => t.play())) : (this.animations.forEach((t => t.cancel())), 
    this.querySelectorAll("details").forEach((t => t.removeAttribute("open")))), this.details.hasAttribute("open") ? setTimeout((() => {
      this.scrollLock && document.body.classList.add("overflow-hidden"), this.isMenu && document.body.classList.add("is-menu-open"), 
      this.summary.setAttribute("aria-expanded", !0);
    })) : (this.scrollLock && document.body.classList.remove("overflow-hidden"), this.isMenu && document.body.classList.remove("is-menu-open"), 
    this.summary.setAttribute("aria-expanded", !1));
  }
  close() {
    this.details.removeAttribute("open"), this.summary.setAttribute("aria-expanded", !1);
  }
  closeParentDetails(t) {
    const e = t.target.closest("details");
    t.stopPropagation(), t.preventDefault(), e === this.details && (e.removeAttribute("open"), 
    e.querySelector("summary").setAttribute("aria-expanded", !1));
  }
});